// extracted by mini-css-extract-plugin
export var card = "_kz-5";
export var cardSelected = "_kz-4";
export var image = "_kz-3";
export var modal = "_kz-0";
export var modalContent = "_kz-1";
export var table = "_kz-2";